import GoogleTagManager from '@redux-beacon/google-tag-manager';
import { createBrowserHistory } from 'history';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { createMiddleware } from 'redux-beacon';
import { createReduxHistoryContext } from 'redux-first-history';
import logger from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';
import analyticsEventMap from './analyticsEventMap';
import reducers from './reducers';
import rootSaga from './sagas';
import storeObject from './storeDeclaration';

const devMiddleWare = [];
const enhancers = [];
if (import.meta.env.MODE !== 'production' && !window.localStorage.getItem('disable-redux-logger')) {
  devMiddleWare.push(logger);
}
const sagaMiddleware = createSagaMiddleware();
const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
});
const analyticsMiddleware = createMiddleware(analyticsEventMap, GoogleTagManager());
const middlewares = [
  routerMiddleware,
  analyticsMiddleware,
  sagaMiddleware,
  thunk,
  ...devMiddleWare,
];

enhancers.push(applyMiddleware(...middlewares));

/* eslint-disable */
const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && import.meta.env.MODE !== 'production'
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;
/* eslint-enable */

const store = createStore(
  combineReducers({
    router: routerReducer,
    ...reducers,
  }),
  composeEnhancers(...enhancers)
);

(storeObject as any).store = store;

if (import.meta.env.MODE !== 'production') {
  // @ts-ignore
  window.store = store;
}

sagaMiddleware.run(rootSaga);

const history = createReduxHistory(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export { history, store };
